// extracted by mini-css-extract-plugin
export default {"mainContainer":"VerificationByUrl_mainContainer__u6rGu","text":"VerificationByUrl_text__eqhi3"};